import { CustomSchema } from "./types"
import { schemas } from "./schames";


export function getSchema<T>(schemaName: string): CustomSchema<T>[] {
  return schemas[schemaName];
}
